var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66602C11.3807 6.66602 12.5 5.54673 12.5 4.16602C12.5 2.7853 11.3807 1.66602 10 1.66602C8.61929 1.66602 7.5 2.7853 7.5 4.16602C7.5 5.54673 8.61929 6.66602 10 6.66602Z",
    stroke: "black",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41693 6.66602C5.05631 6.66976 4.70663 6.79037 4.42039 7.00975C4.13414 7.22913 3.92678 7.53543 3.82943 7.88268L1.75026 15.416C1.68726 15.6598 1.68033 15.9148 1.73 16.1616C1.77966 16.4085 1.88462 16.6409 2.037 16.8414C2.18937 17.0419 2.3852 17.2053 2.60977 17.3192C2.83434 17.4332 3.08181 17.4948 3.33359 17.4993H16.6669C16.9242 17.4993 17.1779 17.4396 17.4082 17.3251C17.6385 17.2106 17.8393 17.0444 17.9946 16.8394C18.15 16.6344 18.2558 16.3962 18.3038 16.1435C18.3517 15.8907 18.3405 15.6304 18.2711 15.3827L16.1669 7.91602C16.0752 7.56052 15.8686 7.24528 15.5792 7.01925C15.2899 6.79322 14.9341 6.66905 14.5669 6.66602H5.41693Z",
    stroke: "black",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightIcon);
export default __webpack_public_path__ + "static/media/weight-icon.f0abfbbfdd951a33ab8218e71b1acf56.svg";
export { ForwardRef as ReactComponent };